export function buildOpendoorAddressFromGeo(geo, options = {}) {
    const includeStreet2 = options.includeStreet2 !== false;
    const g = geo || {};
    const state = (g.stateCode || g.state || '').toString().toUpperCase().slice(0, 2);
    const street1 = (g.address || '').trim() || (g.formatAddress || '').split(',')[0]?.trim() || '';

    if (!street1 || !g.city || !state || !g.zipcode) {
        return null;
    }

    const address = {
        street1,
        city: g.city,
        state,
        postalCode: String(g.zipcode),
    };

    if (includeStreet2 && g.subPremise) {
        address.street2 = g.subPremise;
    }

    return address;
}

export function getPreferredOpendoorHomeSellProduct(opendoorDetails) {
    const homeSell = opendoorDetails && opendoorDetails.products && Array.isArray(opendoorDetails.products.homeSell) ? opendoorDetails.products.homeSell : [];
    if (!homeSell.length) {
        throw new Error('no avaliable data');
    }
    const eligibleItem = homeSell.find((item) => item && item.isEligible === true);
    if (eligibleItem) {
        return eligibleItem;
    }
    const firstItem = homeSell[0];
    if (firstItem && firstItem.denialExplanation) {
        return firstItem;
    }
    throw new Error('no avaliable data');
}

export function logOpendoorAddressDetailsException(message, details = {}) {
    if (typeof window === 'undefined' || typeof window.sendNodeLog !== 'function') {
        return;
    }
    try {
        window.sendNodeLog(message || 'Opendoor', window.location.href, 0, details);
    } catch (e) {
        // ignore logging errors
    }
}
